/** Países oferecidos nos seletores (regras de firewall de entrada). Código ISO-3166-1 alpha-2. */
export const PAISES_OPTIONS = [
    { id: 'BR', label: 'Brasil (BR)' },
    { id: 'US', label: 'Estados Unidos (US)' },
    { id: 'AR', label: 'Argentina (AR)' },
    { id: 'CL', label: 'Chile (CL)' },
    { id: 'CO', label: 'Colômbia (CO)' },
    { id: 'MX', label: 'México (MX)' },
    { id: 'PE', label: 'Peru (PE)' },
    { id: 'UY', label: 'Uruguai (UY)' },
    { id: 'PT', label: 'Portugal (PT)' },
    { id: 'DE', label: 'Alemanha (DE)' },
    { id: 'FR', label: 'França (FR)' },
    { id: 'GB', label: 'Reino Unido (GB)' },
    { id: 'ES', label: 'Espanha (ES)' },
    { id: 'IT', label: 'Itália (IT)' },
    { id: 'NL', label: 'Holanda (NL)' },
    { id: 'CH', label: 'Suíça (CH)' },
    { id: 'SE', label: 'Suécia (SE)' },
    { id: 'PL', label: 'Polônia (PL)' },
    { id: 'RU', label: 'Rússia (RU)' },
    { id: 'CN', label: 'China (CN)' },
    { id: 'JP', label: 'Japão (JP)' },
    { id: 'IN', label: 'Índia (IN)' },
    { id: 'KP', label: 'Coreia do Norte (KP)' },
    { id: 'KR', label: 'Coreia do Sul (KR)' },
    { id: 'SG', label: 'Singapura (SG)' },
    { id: 'AU', label: 'Austrália (AU)' },
    { id: 'CA', label: 'Canadá (CA)' },
    { id: 'ZA', label: 'África do Sul (ZA)' },
    { id: 'NG', label: 'Nigéria (NG)' },
    { id: 'AE', label: 'Emirados Árabes (AE)' },
    { id: 'TR', label: 'Turquia (TR)' },
];

/** "BR" → "Brasil (BR)"; código fora da lista volta como está. */
export function rotuloPais(codigo: string): string {
    return PAISES_OPTIONS.find((p) => p.id === codigo.toUpperCase())?.label ?? codigo.toUpperCase();
}
